module.exports = __webpack_public_path__ + "img/hibob.61be50a9.svg";